// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3YFdl","image":"Header_image__3toR-","name":"Header_name__1ySWl","info":"Header_info__1s7sq","infoRow":"Header_infoRow__XJD-v"};